// ModeloHeaderDesktop.js
import React from 'react';
import './ModeloHeaderDesktop.css';

const ModeloHeaderDesktop = ({ nombre, serie, descripcion, imagenUrl }) => {

  const imagePath = '/images/ModeloBanner/model-background-desktop.webp';

  return (
    <div className="modelo-header-desktop-banner" style={{ backgroundImage: `url(${imagePath})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      {/* Ghost model name in the background */}
      <div className="modelo-header-desktop-ghost">{nombre}</div>

      <div className="modelo-header-desktop-container">
        {/* Left column for text content */}
        <div className="modelo-header-desktop-texto">
          <h2 className="modelo-header-desktop-title">{nombre}</h2>
          <h3 className="modelo-header-desktop-serie">Serie: {serie}</h3>
          <p className="modelo-header-desktop-description">{descripcion}</p>
        </div>

        {/* Right column for image */}
        <div className="modelo-header-desktop-image-container">
          <img src={imagenUrl} alt={nombre} className="modelo-header-desktop-image" />
        </div>
      </div>

    </div>
  );
};

export default ModeloHeaderDesktop;
